module.exports = __webpack_public_path__ + "static/media/charlesdeluvio-1zIP0skBAfE-unsplash.e837b340.jpg";